import moment from 'moment';

const getDateFromSelectedFilter = (value: number) => {
  return moment().subtract(value, 'd').format('YYYY-MM-DD');
};

export default getDateFromSelectedFilter;
